module.exports = __webpack_public_path__ + "media/images/mobile/dummy09-9458c46ca80e421b78cc671a9e9f6b5f.jpg";